<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Noty'" [name]="'Dodaj notę'"
                xmlns="http://www.w3.org/1999/html"></app-breadcrumb>
<div class="invoice-note-create" [formGroup]="invoiceNoteForm" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="invoiceNoteForm.invalid || disabledInvoiceNote || processingRequest" mat-stroked-button
            color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row">
          <h3>Dane noty</h3>
        </div>
        <app-dict
          [label]="'Firma'" [dictType]="'company'"
          [control]="companyControl"
          [required]="true"
          [multiple]="false"
        ></app-dict>
        <app-dict-all-contracts
          fxFlex="100" label="Umowa"
          [control]="contractControl"
          [required]="!withoutContractControl.value"
          [companyId]="companyId"
          (selectedContract)="contractChanged($event)"
          [showOwnerName]="true"
          [showStatus]="true"
          [partnershipContracts]="true"
        ></app-dict-all-contracts>

        <mat-slide-toggle [formControl]="withoutContractControl">Bez umowy</mat-slide-toggle>

        <ng-container *ngIf="withoutContractControl.value">
          <h4>Dane odbiorcy noty</h4>
          <mat-form-field fxFlex="100">
            <mat-label>Nazwa firmy / Imię i nazwisko</mat-label>
            <input matInput required [formControl]="recipientNameControl">
            <mat-error *ngIf="recipientNameControl.hasError('required')">To pole jest wymagane</mat-error>
            <mat-error
              *ngIf="recipientNameControl.hasError('backendError')">{{ recipientNameControl.getError('backendError') }}
            </mat-error>
          </mat-form-field>
          <div fxFlex="100" fxLayout="row" fxLayoutGap="15px">

            <mat-form-field fxFlex="30">
              <mat-label>Kod pocztowy</mat-label>
              <input matInput required [formControl]="recipientZipCodeControl" mask="99-999" [showMaskTyped]="true" [dropSpecialCharacters]="false">
              <mat-error *ngIf="recipientZipCodeControl.hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="recipientZipCodeControl.hasError('pattern')">Podaj kod w formacie 00-000</mat-error>
              <mat-error
                *ngIf="recipientZipCodeControl.hasError('backendError')">{{ recipientZipCodeControl.getError('backendError') }}
              </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="70">
              <mat-label>Poczta</mat-label>
              <input matInput required [formControl]="recipientPostOfficeControl">
              <mat-error *ngIf="recipientPostOfficeControl.hasError('required')">To pole jest wymagane</mat-error>
              <mat-error
                *ngIf="recipientPostOfficeControl.hasError('backendError')">{{ recipientPostOfficeControl.getError('backendError') }}
              </mat-error>
            </mat-form-field>
          </div>

          <mat-form-field fxFlex="100">
            <mat-label>Ulica i numery</mat-label>
            <input matInput required [formControl]="recipientStreetControl">
            <mat-error *ngIf="recipientStreetControl.hasError('required')">To pole jest wymagane</mat-error>
            <mat-error
              *ngIf="recipientStreetControl.hasError('backendError')">{{ recipientStreetControl.getError('backendError') }}
            </mat-error>
          </mat-form-field>

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
              <mat-slide-toggle
                [formControl]="useNipControl"
                (change)="selectIdentifier('nip')">
                NIP
              </mat-slide-toggle>

              <mat-slide-toggle
                [formControl]="usePeselControl"
                (change)="selectIdentifier('pesel')">
                PESEL
              </mat-slide-toggle>
            </div>

          </div>
          <mat-form-field fxFlex="100" *ngIf="!usePeselControl.value">
            <mat-label>NIP</mat-label>
            <input matInput [formControl]="recipientNipControl" mask="0000000000">
            <mat-error *ngIf="recipientNipControl.hasError('required')">Podaj NIP</mat-error>
            <mat-error *ngIf="recipientNipControl.hasError('pattern')">NIP musi składać się z 10 cyfr</mat-error>
            <mat-error *ngIf="recipientNipControl.hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
            <mat-error *ngIf="recipientNipControl.hasError('backendError')">{{ recipientNipControl.getError('backendError') }}</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100" *ngIf="usePeselControl.value">
            <mat-label>PESEL</mat-label>
            <input matInput required [formControl]="recipientPeselControl">
            <mat-error *ngIf="recipientPeselControl.hasError('required')">To pole jest wymagane</mat-error>
            <mat-error *ngIf="recipientPeselControl.hasError('pattern')">Podaj prawidłowy numer PESEL</mat-error>
            <mat-error *ngIf="recipientPeselControl.hasError('backendError')">{{ recipientPeselControl.getError('backendError') }}</mat-error>
            <mat-error *ngIf="recipientPeselControl.hasError('invalidPesel')">Nieprawidłowy numer PESEL</mat-error>
          </mat-form-field>
        </ng-container>

        <mat-form-field fxFlex="100">
          <mat-label>Kwota</mat-label>
          <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="grossControl">
          <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="grossControl.hasError('min')">Kwota musi być większa od zera</mat-error>
          <mat-error *ngIf="grossControl.hasError('backendError')">{{ grossControl.getError('backendError') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100">
          <mat-label>Powód wystawienia noty</mat-label>
          <input [required]="true" matInput placeholder="Powód wystawienia noty" [formControl]="reasonControl">
          <mat-error *ngIf="reasonControl.hasError('required')">Musisz podać powód</mat-error>
        </mat-form-field>

      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="invoiceNoteForm.invalid || disabledInvoiceNote || processingRequest" mat-stroked-button
            color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
</div>
